<template>
  <section>
    <div class="fileBox">
      <com-tabs
        :list="libraryInfo.obj.tabs"
        class="fileBox-tabs"
        :default-tab="activeTab"
        @change="changeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="fileBox-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>
      <div class="fileBox-content">
        <com-step0 v-show="activeTab == 0" :obj="libraryInfo.data.data1" />
        <com-step1
          v-show="activeTab == 1"
          :obj="libraryInfo.data.data2"
          :config="libraryInfo.obj.table2"
        />
        <com-step2 v-show="activeTab == 2" :obj="libraryInfo.data.data3" :table-head="libraryInfo.obj.tableHead" />
        <com-step3 v-show="activeTab == 3" :obj="libraryInfo.data.data4" />
      </div>
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comTabs from '@/components/comTabs'
import comStep0 from './details/comStep0.vue'
import comStep1 from './details/comStep1.vue'
import comStep2 from './details/comStep2.vue'
import comStep3 from './details/comStep3.vue'
export default {
  name: 'ComFile',
  components: { comTabs, comStep0, comStep1, comStep2, comStep3 },
  props: {},
  data() {
    return {
      libraryInfo: mock.library.file.viewInfo,
      activeTab: 0
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    changeTab(x, y) {
      this.activeTab = x
    }
  }
}
</script>
<style lang='scss' scoped>
.fileBox {
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  &-tabs {
    margin: 0 35px;
    &-item {
      text-align: center;
      @include fun-design(7);
      line-height: 40px;
      width: 60px;
      cursor: pointer;
    }
    .activeTab {
      @include fun-active();
    }
  }
  &-content {
    // height: calc(100vh - 190px);
    flex: 1;
    width: 100%;
    margin-top: 20px;
    @include fun-layout(2);
    > section {
      height: 100%;
    }
  }
}
</style>
